import { GetPlatformCatalogsParams, PlatformCatalogSortByParam, PublicationStatus } from "@bvhi/backend-api/apis";

export const defaultCatalogsFilter: GetPlatformCatalogsParams = {
  page: 0,
  size: 25,
  sort: [PlatformCatalogSortByParam.NAME_ASC],
  platformCatalogStatus: [PublicationStatus.PUBLISHED, PublicationStatus.DRAFT],
};
